export const environment = {
  production: false,
  hostUrl: 'https://liff-dev.swishbkk.com',
  apiUrl: 'https://liff-dev.swishbkk.com/api',

};
